import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'ps-exam',
  templateUrl: './exam.component.html',
  styleUrls: ['./exam.component.scss']
})
export class ExamComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
